module.exports = __webpack_public_path__ + "img/Rel.Colleagues@2x.03f158b8.png";